import { STATUS_COLOURS } from "@/lib/constants";

const textOnDark = ["In Progress", "Long-Term Project", "Received", "Awaiting Quote Approval", "Completed", "Awaiting Drop-off", "Cancelled"];

export const StatusBadge = ({ status, className = "" }) => {
  const bg = STATUS_COLOURS[status] || "#94A3B8";
  const dark = textOnDark.includes(status);
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-sm font-display uppercase tracking-wider text-xs font-bold ${className}`}
      style={{ backgroundColor: bg, color: dark ? "#FFFFFF" : "#0F172A" }}
      data-testid={`status-badge-${status.toLowerCase().replace(/\s+/g, "-")}`}
    >
      <span className="inline-block size-1.5 rounded-full" style={{ backgroundColor: dark ? "#FFD93D" : "#0F172A" }} />
      {status}
    </span>
  );
};

export default StatusBadge;
